import { render, staticRenderFns } from "./venue-events.datagrid.vue?vue&type=template&id=0869f937&scoped=true&"
import script from "./venue-events.datagrid.vue?vue&type=script&lang=js&"
export * from "./venue-events.datagrid.vue?vue&type=script&lang=js&"
import style0 from "./venue-events.datagrid.vue?vue&type=style&index=0&id=0869f937&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0869f937",
  null
  
)

export default component.exports